import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function SimpleSlider() {

    const sliderJsonData = [
        {
            image: "images/login-slider.jpg",
            category: "Living Room",
        },
        {
            image: "images/login-slider-1.png",
            category: "Bedrooms",
        },
        {
            image: "images/login-slider-2.png",
            category: "Office",
        },
        {
            image: "images/login-slider.jpg",
            category: "Dining Room",
        },
        {
            image: "images/login-slider-1.png",
            category: "Kitchen",
        },
    ];

    const [sliderData, setSliderData] = useState([]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };

    return (
        <>

            <div className="h-full w-full md:h-screen">
                {sliderJsonData.length > 0 ? (
                    <Slider {...settings} className="login-slider">
                        {sliderJsonData.map((item, index) => (
                            <div key={index} className="md:h-screen">
                                <div className="text-center">
                                    <img src={item.image} alt={item.category} className="h-screen w-full object-cover" />
                                </div>
                            </div>
                        ))}
                    </Slider>
                ) : (
                    <p className="text-center">Loading...</p>
                )}
            </div>
        </>
    );
}